import { render } from "./CustomerAttributes.vue?vue&type=template&id=5de7a2de&scoped=true"
import script from "./CustomerAttributes.vue?vue&type=script&lang=js"
export * from "./CustomerAttributes.vue?vue&type=script&lang=js"

import "./CustomerAttributes.vue?vue&type=style&index=0&id=5de7a2de&scoped=true&lang=css"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de7a2de"]])

export default __exports__